export const MATCH_MODE_ALL = 'all';
export const MATCH_MODE_ANY = 'any';

export type MatchMode = typeof MATCH_MODE_ALL | typeof MATCH_MODE_ANY;

export interface RoutePermissionSet {
  matchMode: MatchMode;
  allow: string[];
  deny?: string[];
  redirectOnDeny?: string;
}

export const hasRequiredPermissions = (
  userPermissions: string[] | undefined,
  requiredPermissions: string[],
  matchMode: MatchMode
): boolean => {
  if (!userPermissions) return false;
  if (requiredPermissions.length === 0) return true;

  const currentPermissions = userPermissions;

  function matches(permission: string) {
    function userPermissionMatches(userPermission: string) {
      return userPermission === permission || userPermission.startsWith(`${permission}.`);
    }

    return currentPermissions.some(userPermissionMatches);
  }

  const { hasAll, hasAny } = requiredPermissions.reduce<{ hasAll: boolean; hasAny: boolean }>(
    (acc, permission) => {
      const match = matches(permission);
      return { hasAll: acc.hasAll && match, hasAny: acc.hasAny || match };
    },
    { hasAll: true, hasAny: false }
  );

  return matchMode === MATCH_MODE_ANY ? hasAny : hasAll;
};

export const hasAccess = (userPermissions: string[] | undefined, rule: RoutePermissionSet): boolean => {
  if (!userPermissions) return false;

  const hasDeniedPermission = Boolean(
    rule.deny && rule.deny.length > 0 && hasRequiredPermissions(userPermissions, rule.deny, MATCH_MODE_ANY)
  );

  if (hasDeniedPermission) {
    return false;
  }

  return hasRequiredPermissions(userPermissions, rule.allow, rule.matchMode);
};
